import { ModuleWithProviders, NgModule } from '@angular/core';
import { BatchAutocompleteLibComponent } from './batch-autocomplete-lib.component';
import {AutocompleteComponent} from './autocomplete/autocomplete.component';
import { HighlightPipe } from './autocomplete/highlight.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';


@NgModule({
  declarations: [
    BatchAutocompleteLibComponent, AutocompleteComponent, HighlightPipe
  ],
  imports: [
    CommonModule, FormsModule, HttpClientModule
  ],
  exports: [
    BatchAutocompleteLibComponent, AutocompleteComponent, HighlightPipe
  ]
})
export class BatchAutocompleteLibModule {

  public static forRoot(domainServer: string, apiKey: string, ): ModuleWithProviders<BatchAutocompleteLibModule> {
    // User config get logged here
    return {
      ngModule: BatchAutocompleteLibModule,
      providers: [{provide: 'Params', useValue: {apiKey, domainServer}}]
    };
  }
}
